<bs-linear-bet-builder-selections-list [pick]="pick" [inlineDetails]="true" />

<bs-betslip-betbuilder-edit-pick-button [pick]="pick" [title]="addPicksMessage" [hideIcon]="true" [isLinear]="true" />
